function getResolverForContentType(contentType) {
  const type = contentType == null ? void 0 : contentType.toLowerCase();
  switch (true) {
    case (type == null ? void 0 : type.includes("application/json")):
      return "json";
    case (type == null ? void 0 : type.includes("application/octet-stream")):
      return "blob";
    case (type == null ? void 0 : type.includes("multipart/form-data")):
      return "formData";
    default:
      return "text";
  }
}
export {
  getResolverForContentType as g
};
//# sourceMappingURL=get-resolver-for-content-type-DlHTDn7n.js.map
